import React, { useEffect } from 'react'
import RegistrationDashboardLayout from './RegistrationDashboardLayout'
import { useContext } from 'react';
import EventContext from "../contexts/EventContext";
import { useState } from 'react';
import { API_URL } from '../config';
import { Youtube, Copy, CheckCircle, ExternalLink, Users, Video, Eye, ListVideo, Linkedin, Pencil, X, Film, Plus, Trash2 } from 'lucide-react';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';

const YOUTUBE_CONNECT_URL = 'https://manager.event2one.com/videos/upload-to-youtube/get_token.php';
const UPLOAD_API_URL = 'https://manager.event2one.com/videos/upload-to-youtube/upload_api.php';
const UPLOAD_API_KEY = 'mgv_yt_upload_2026';

const formatCount = (n) => {
    if (n === null || n === undefined) return null;
    if (n >= 1000000) return `${(n / 1000000).toFixed(1).replace('.0', '')} M`;
    if (n >= 1000) return `${(n / 1000).toFixed(1).replace('.0', '')} k`;
    return String(n);
};

const RegistrationDashbordParams = ({ isAdmin, profile }) => {

    const eventContext = useContext(EventContext);

    const { currentEvent } = eventContext;

    const { ownerIdContact } = useParams();

    const [ville, setVille] = useState();

    const [copied, setCopied] = useState(false);

    const [youtubeInfo, setYoutubeInfo] = useState(null);
    const [youtubeInfoLoading, setYoutubeInfoLoading] = useState(false);

    const [coordinateurContact, setCoordinateurContact] = useState(null);

    useEffect(() => {
        if (!ownerIdContact) { setCoordinateurContact(null); return; }
        fetch(`${API_URL}?action=getContact&id_contact=${ownerIdContact}`)
            .then(res => res.json())
            .then(data => setCoordinateurContact(data))
            .catch(() => setCoordinateurContact(null));
    }, [ownerIdContact]);

    const COLOR_FIELDS = [
        { label: 'Couleur principale', key: 'color_hexa_1' },
        { label: 'Couleur secondaire', key: 'color_hexa_2' },
        { label: 'Couleur tertiaire', key: 'color_hexa_3' },
    ];

    const [colorsValue, setColorsValue] = useState({});
    const [colorsEditing, setColorsEditing] = useState(false);
    const [colorsDraft, setColorsDraft] = useState({});
    const [colorsSaving, setColorsSaving] = useState(false);
    const [colorsEditOpenedAt, setColorsEditOpenedAt] = useState(0);

    useEffect(() => {
        setColorsValue({
            color_hexa_1: currentEvent?.event_ligne?.color_hexa_1 || '',
            color_hexa_2: currentEvent?.event_ligne?.color_hexa_2 || '',
            color_hexa_3: currentEvent?.event_ligne?.color_hexa_3 || '',
        });
    }, [currentEvent?.event_ligne?.color_hexa_1, currentEvent?.event_ligne?.color_hexa_2, currentEvent?.event_ligne?.color_hexa_3]);

    const handleColorsEdit = () => {
        setColorsDraft(colorsValue);
        setColorsEditOpenedAt(Date.now());
        setColorsEditing(true);
    };

    const handleColorsCancel = () => {
        setColorsEditing(false);
    };

    const handleColorsSave = async () => {
        const idEventLigne = currentEvent?.event_ligne?.id_event_ligne;
        if (!idEventLigne) return;
        setColorsSaving(true);
        try {
            await fetch(`${API_URL}?action=updateEventLigne`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id_event_ligne: idEventLigne,
                    color_hexa_1: colorsDraft.color_hexa_1,
                    color_hexa_2: colorsDraft.color_hexa_2,
                    color_hexa_3: colorsDraft.color_hexa_3,
                }),
            });
            setColorsValue(colorsDraft);
            setColorsEditing(false);
        } finally {
            setColorsSaving(false);
        }
    };

    const [linkedinValue, setLinkedinValue] = useState('');
    const [linkedinEditing, setLinkedinEditing] = useState(false);
    const [linkedinDraft, setLinkedinDraft] = useState('');
    const [linkedinSaving, setLinkedinSaving] = useState(false);

    useEffect(() => {
        setLinkedinValue(currentEvent?.event_ligne?.linkedin_profiles_to_connect_width || '');
    }, [currentEvent?.event_ligne?.linkedin_profiles_to_connect_width]);

    const handleLinkedinEdit = () => {
        setLinkedinDraft(linkedinValue);
        setLinkedinEditing(true);
    };

    const handleLinkedinCancel = () => {
        setLinkedinEditing(false);
    };

    const handleLinkedinSave = async () => {
        const idEventLigne = currentEvent?.event_ligne?.id_event_ligne;
        if (!idEventLigne) return;
        setLinkedinSaving(true);
        try {
            await fetch(`${API_URL}?action=updateEventLigne`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id_event_ligne: idEventLigne,
                    linkedin_profiles_to_connect_width: linkedinDraft,
                }),
            });
            setLinkedinValue(linkedinDraft);
            setLinkedinEditing(false);
        } finally {
            setLinkedinSaving(false);
        }
    };

    const [retention, setRetention] = useState(null);
    const [retentionInput, setRetentionInput] = useState('');
    const [retentionSaving, setRetentionSaving] = useState(false);

    useEffect(() => {
        const idEvent = currentEvent?.id_event;
        if (!idEvent) return;
        const fd = new FormData();
        fd.append('action', 'get_event_retention');
        fd.append('id_event', idEvent);
        fetch(UPLOAD_API_URL, { method: 'POST', headers: { 'X-Api-Key': UPLOAD_API_KEY }, body: fd })
            .then(r => r.json())
            .then(d => { setRetention(d); setRetentionInput(String(d.retention_days ?? '')); })
            .catch(() => { });
    }, [currentEvent?.id_event]);

    const handleSaveRetention = async () => {
        const idEvent = currentEvent?.id_event;
        const days = parseInt(retentionInput, 10);
        if (!idEvent || !days || days <= 0) return;
        setRetentionSaving(true);
        try {
            const fd = new FormData();
            fd.append('action', 'set_event_retention');
            fd.append('id_event', idEvent);
            fd.append('retention_days', days);
            const d = await fetch(UPLOAD_API_URL, { method: 'POST', headers: { 'X-Api-Key': UPLOAD_API_KEY }, body: fd }).then(r => r.json());
            if (d.success) setRetention({ id_event: idEvent, retention_days: days, is_default: false });
        } finally {
            setRetentionSaving(false);
        }
    };

    const coordinateurSociete = coordinateurContact?.societe || currentEvent?.event_ligne?.event_ligne_nom || currentEvent?.nom || '';
    const coordinateurEmail = coordinateurContact?.mail || '';
    const youtubeConnectPrefilled = !!(coordinateurSociete || coordinateurEmail);

    const youtubeConnectUrl = (() => {
        const params = new URLSearchParams();
        if (coordinateurSociete) params.set('organisation', coordinateurSociete);
        if (coordinateurEmail) params.set('email', coordinateurEmail);
        const qs = params.toString();
        return qs ? `${YOUTUBE_CONNECT_URL}?${qs}` : YOUTUBE_CONNECT_URL;
    })();

    const handleCopyYoutubeLink = () => {
        navigator.clipboard.writeText(youtubeConnectUrl).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };

    // Organisation réelle de l'événement — résolue exactement comme dans les cartes
    // vidéo (VideoCard/TabUpload), qui utilisent resolve_event_organisation plutôt que
    // currentEvent.organisation_id (souvent absent/incorrect). Sans ça, les playlists
    // ajoutées ici finissent sous le mauvais organisation_id et n'apparaissent jamais
    // dans le sélecteur des cartes vidéo.
    const [resolvedOrgId, setResolvedOrgId] = useState(1);

    useEffect(() => {
        const idEventLigne = currentEvent?.event_ligne?.id_event_ligne;
        if (!idEventLigne) { setResolvedOrgId(1); return; }
        const fd = new FormData();
        fd.append('action', 'resolve_event_organisation');
        fd.append('id_event_ligne', idEventLigne);
        fetch(UPLOAD_API_URL, { method: 'POST', headers: { 'X-Api-Key': UPLOAD_API_KEY }, body: fd })
            .then(r => r.json())
            .then(d => setResolvedOrgId(d.organisation_id ?? 1))
            .catch(() => setResolvedOrgId(1));
    }, [currentEvent?.event_ligne?.id_event_ligne]);

    const getYoutubeChannelInfo = async () => {
        const idEventLigne = currentEvent?.event_ligne?.id_event_ligne;
        if (!idEventLigne) return;
        setYoutubeInfoLoading(true);
        const fd = new FormData();
        fd.append('action', 'get_youtube_channel_info');
        fd.append('organisation_id', resolvedOrgId);
        fd.append('id_event_ligne', idEventLigne);
        try {
            const res = await fetch(UPLOAD_API_URL, { method: 'POST', headers: { 'X-Api-Key': UPLOAD_API_KEY }, body: fd });
            const data = await res.json();
            setYoutubeInfo(data);
        } catch (e) {
            setYoutubeInfo(null);
        } finally {
            setYoutubeInfoLoading(false);
        }
    };

    const [eventPlaylists, setEventPlaylists] = useState([]);
    const [playlistsLoading, setPlaylistsLoading] = useState(false);
    const [newPlaylistId, setNewPlaylistId] = useState('');
    const [newPlaylistLabel, setNewPlaylistLabel] = useState('');
    const [playlistSaving, setPlaylistSaving] = useState(false);
    const [playlistDeletingId, setPlaylistDeletingId] = useState(null);

    const getEventYoutubePlaylists = async () => {
        const idEventLigne = currentEvent?.event_ligne?.id_event_ligne;
        if (!idEventLigne) return;
        setPlaylistsLoading(true);
        try {
            const fd = new FormData();
            fd.append('action', 'get_event_youtube_playlists');
            fd.append('organisation_id', resolvedOrgId);
            fd.append('id_event_ligne', idEventLigne);
            const data = await fetch(UPLOAD_API_URL, { method: 'POST', headers: { 'X-Api-Key': UPLOAD_API_KEY }, body: fd }).then(r => r.json());
            setEventPlaylists(Array.isArray(data.playlists) ? data.playlists : []);
        } catch (e) {
            setEventPlaylists([]);
        } finally {
            setPlaylistsLoading(false);
        }
    };

    const handleAddPlaylist = async () => {
        const idEventLigne = currentEvent?.event_ligne?.id_event_ligne;
        if (!idEventLigne || !newPlaylistId.trim()) return;
        setPlaylistSaving(true);
        try {
            const fd = new FormData();
            fd.append('action', 'add_event_youtube_playlist');
            fd.append('organisation_id', resolvedOrgId);
            fd.append('id_event_ligne', idEventLigne);
            fd.append('youtube_playlist_id', newPlaylistId.trim());
            fd.append('label', newPlaylistLabel.trim());
            const data = await fetch(UPLOAD_API_URL, { method: 'POST', headers: { 'X-Api-Key': UPLOAD_API_KEY }, body: fd }).then(r => r.json());
            setEventPlaylists(Array.isArray(data.playlists) ? data.playlists : []);
            setNewPlaylistId('');
            setNewPlaylistLabel('');
        } finally {
            setPlaylistSaving(false);
        }
    };

    const handleDeletePlaylist = async (id) => {
        const idEventLigne = currentEvent?.event_ligne?.id_event_ligne;
        setPlaylistDeletingId(id);
        try {
            const fd = new FormData();
            fd.append('action', 'delete_event_youtube_playlist');
            fd.append('id', id);
            fd.append('organisation_id', resolvedOrgId);
            fd.append('id_event_ligne', idEventLigne ?? '');
            const data = await fetch(UPLOAD_API_URL, { method: 'POST', headers: { 'X-Api-Key': UPLOAD_API_KEY }, body: fd }).then(r => r.json());
            setEventPlaylists(Array.isArray(data.playlists) ? data.playlists : []);
        } finally {
            setPlaylistDeletingId(null);
        }
    };

    const getCycleLangEventLigne = async () => {

        await fetch(`${API_URL}?action=getCycleLangEventLigne&params= WHERE id_event_ligne = ${currentEvent?.event_ligne.id_event_ligne}  `)
            .then(res => res.json())
            .then(res => {
                const villeEntry = Array.isArray(res)
                    ? res.find(item => item?.id_cycle_lang?.cycle_lang_type === 'collectif_geographique' && item?.id_cycle_lang?.cycle_lang_categorie === 'ville')
                    : null;
                setVille(villeEntry || null);
            })
    }

    const [villeVideoFootage, setVilleVideoFootage] = useState(null);

    useEffect(() => {
        const idCycleLang = ville?.id_cycle_lang?.id_cycle_lang;
        if (!idCycleLang) { setVilleVideoFootage(null); return; }
        fetch(`${API_URL}?action=getAttachedFiles&filter=${encodeURIComponent(` WHERE attached_file_table='cycle_lang' AND primary_key_value=${idCycleLang} AND id_attached_file_type=109 `)}`)
            .then(res => res.json())
            .then(res => setVilleVideoFootage(res?.[0] || null))
            .catch(() => setVilleVideoFootage(null));
    }, [ville]);

    const [animateurs, setAnimateurs] = useState([]);
    const [animateursLoading, setAnimateursLoading] = useState(false);
    const [relaiSavingId, setRelaiSavingId] = useState(null);

    const getAnimateurs = async () => {
        const idEvent = currentEvent?.id_event;
        if (!idEvent) return;
        setAnimateursLoading(true);
        try {
            const res = await fetch(`${API_URL}?action=getPartenairesLight&params=${encodeURIComponent(` AND cf.id_event=${idEvent} AND cf.statut=27 AND cf.id_contact=1389`)}`)
                .then(r => r.json());
            setAnimateurs(Array.isArray(res) ? res : []);
        } catch (e) {
            setAnimateurs([]);
        } finally {
            setAnimateursLoading(false);
        }
    };

    const handleSetRelaiAutorise = async (idConferencier, value) => {
        setRelaiSavingId(idConferencier);
        try {
            await fetch(`${API_URL}?action=updateConferencier`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id_conferencier: idConferencier,
                    autorise_relai_linkedin: value ? 1 : 0,
                }),
            });
            setAnimateurs(prev => prev.map(a => a.id_conferencier === idConferencier ? { ...a, autorise_relai_linkedin: value ? 1 : 0 } : a));
        } finally {
            setRelaiSavingId(null);
        }
    };

    useEffect(() => {

        getCycleLangEventLigne();
        getYoutubeChannelInfo();
        getEventYoutubePlaylists();
        getAnimateurs();
    }, [currentEvent, resolvedOrgId]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <RegistrationDashboardLayout
            isAdmin={isAdmin}
            profile={profile}
        >
            <header className="mb-fib-13">
                <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-fib-2">Paramètres de votre opération</h1>
                <p className="text-gray-500 dark:text-neutral-400">Gérez les paramètres de votre opération.</p>
            </header>

            <div className="flex flex-col gap-fib-8">

                <div className="flex items-center gap-fib-3">
                    <span className="flex items-center justify-center w-6 h-6 rounded-full bg-e2o-500 text-white text-xs font-bold flex-shrink-0">1</span>
                    <h2 className="text-base font-bold text-gray-900 dark:text-white">Livraison de la vidéo aux interviewés pour diffusion sur LinkedIn, site web et newsletter</h2>
                </div>

                <section className="p-fib-5 sm:p-fib-8 bg-white dark:bg-neutral-900 border border-gray-100 dark:border-neutral-800 rounded-2xl shadow-sm">
                    <h3 className="text-lg font-bold mb-fib-2 text-gray-900 dark:text-white">Rétention du fichier natif</h3>
                    <p className="text-gray-500 dark:text-neutral-400 mb-fib-5">
                        Durée pendant laquelle les fichiers vidéo natifs de cet événement sont conservés avant suppression automatique.
                    </p>
                    <div className="flex items-end gap-fib-2">
                        <div>
                            <label className="block text-xs font-medium text-gray-500 dark:text-neutral-400 mb-fib-1">
                                Durée de rétention (jours)
                                {retention?.is_default && <span className="italic"> — valeur par défaut</span>}
                            </label>
                            <input
                                type="number"
                                min="1"
                                value={retentionInput}
                                onChange={e => setRetentionInput(e.target.value)}
                                className="w-28 px-3 py-2 text-sm bg-gray-50 dark:bg-neutral-800 border border-gray-200 dark:border-neutral-700 rounded-lg text-gray-700 dark:text-neutral-200 focus:outline-none focus:ring-2 focus:ring-e2o-500"
                            />
                        </div>
                        <button
                            onClick={handleSaveRetention}
                            disabled={retentionSaving || !currentEvent?.id_event}
                            className="flex items-center gap-1 px-3 py-2 text-xs font-medium text-white bg-e2o-500 hover:bg-e2o-600 rounded-lg disabled:opacity-50"
                        >
                            <CheckCircle size={13} />
                            {retentionSaving ? 'Enregistrement…' : 'Enregistrer'}
                        </button>
                    </div>
                </section>

                <section className="p-fib-5 sm:p-fib-8 bg-white dark:bg-neutral-900 border border-gray-100 dark:border-neutral-800 rounded-2xl shadow-sm">
                    <div className="flex items-center justify-between mb-fib-2 max-w-2xl">
                        <h3 className="text-lg font-bold flex items-center gap-fib-2 text-gray-900 dark:text-white">
                            <Linkedin size={20} className="text-[#0A66C2]" />
                            LinkedIn — Profils &amp; pages à connecter
                        </h3>
                        {!linkedinEditing && (
                            <button
                                onClick={handleLinkedinEdit}
                                className="shrink-0 flex items-center gap-1 px-3 py-1.5 text-xs font-medium border border-gray-200 dark:border-neutral-700 rounded-lg hover:bg-gray-50 dark:hover:bg-neutral-800 dark:text-neutral-200"
                            >
                                <Pencil size={13} />
                                Éditer
                            </button>
                        )}
                    </div>
                    <p className="text-gray-500 dark:text-neutral-400 mb-fib-5">
                        Profils et pages LinkedIn à inviter à se connecter, associés à cet événement.
                    </p>

                    {linkedinEditing ? (
                        <div className="max-w-2xl">
                            <textarea
                                value={linkedinDraft}
                                onChange={e => setLinkedinDraft(e.target.value)}
                                placeholder="https://www.linkedin.com/in/..."
                                rows={6}
                                className="w-full border border-gray-200 dark:border-neutral-700 rounded-lg px-3 py-2 text-sm font-mono bg-white dark:bg-neutral-900 text-gray-800 dark:text-neutral-200 focus:outline-none focus:ring-2 focus:ring-e2o-500"
                            />
                            <div className="flex items-center gap-fib-2 mt-fib-3">
                                <button
                                    onClick={handleLinkedinSave}
                                    disabled={linkedinSaving}
                                    className="flex items-center gap-1 px-3 py-1.5 text-xs font-medium text-white bg-e2o-500 hover:bg-e2o-600 rounded-lg disabled:opacity-50"
                                >
                                    <CheckCircle size={13} />
                                    {linkedinSaving ? 'Enregistrement…' : 'Enregistrer'}
                                </button>
                                <button
                                    onClick={handleLinkedinCancel}
                                    disabled={linkedinSaving}
                                    className="flex items-center gap-1 px-3 py-1.5 text-xs font-medium border border-gray-200 dark:border-neutral-700 rounded-lg hover:bg-gray-50 dark:hover:bg-neutral-800 dark:text-neutral-200 disabled:opacity-50"
                                >
                                    <X size={13} />
                                    Annuler
                                </button>
                            </div>
                        </div>
                    ) : (() => {
                        const linkedinProfiles = linkedinValue
                            .split('\n')
                            .map(l => l.trim())
                            .filter(Boolean);
                        if (!linkedinProfiles.length) {
                            return <p className="text-sm text-gray-400 dark:text-neutral-500">Aucun profil renseigné.</p>;
                        }
                        return (
                            <div className="flex flex-col gap-fib-2 max-w-2xl">
                                {linkedinProfiles.map((url, i) => (
                                    <div key={i} className="flex items-center justify-between gap-2 border border-gray-200 dark:border-neutral-700 rounded-lg px-3 py-2 bg-gray-50 dark:bg-neutral-800">
                                        <span className="text-sm font-mono text-gray-800 dark:text-neutral-200 truncate">{url}</span>
                                        <a
                                            href={url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="shrink-0 text-gray-400 hover:text-e2o-500 transition-colors"
                                            title="Ouvrir"
                                        >
                                            <ExternalLink size={15} />
                                        </a>
                                    </div>
                                ))}
                            </div>
                        );
                    })()}
                </section>

                <div className="flex items-center gap-fib-3 mt-fib-5">
                    <span className="flex items-center justify-center w-6 h-6 rounded-full bg-e2o-500 text-white text-xs font-bold flex-shrink-0">2</span>
                    <h2 className="text-base font-bold text-gray-900 dark:text-white">Publication automatique de la vidéo sur une chaîne ou une playlist YouTube</h2>
                </div>

                <section className="p-fib-5 sm:p-fib-8 bg-white dark:bg-neutral-900 border border-gray-100 dark:border-neutral-800 rounded-2xl shadow-sm">
                    <h3 className="text-lg font-bold mb-fib-2 flex items-center gap-fib-2 text-gray-900 dark:text-white">
                        <Youtube size={20} className="text-red-600" />
                        Connexion YouTube
                    </h3>
                    <p className="text-gray-500 dark:text-neutral-400 mb-fib-5">
                        J'utilise ce lien pour connecter ma chaîne YouTube à la plateforme, afin que mes vidéos soient publiées automatiquement sur ma chaîne ou une playlist dédiée.
                    </p>
                    <p> {youtubeConnectPrefilled ? ' Organisation et e-mail sont déjà préremplis.' : ''}</p>
                    <div className="flex gap-fib-2 max-w-2xl">
                        <input
                            readOnly
                            value={youtubeConnectUrl}
                            className="flex-1 border border-gray-200 dark:border-neutral-700 rounded-lg px-3 py-2 text-xs font-mono bg-gray-50 dark:bg-neutral-800 text-gray-600 dark:text-neutral-300 focus:outline-none"
                        />
                        <button
                            onClick={handleCopyYoutubeLink}
                            className="shrink-0 flex items-center gap-1 px-3 py-2 text-xs font-medium border border-gray-200 dark:border-neutral-700 rounded-lg hover:bg-gray-50 dark:hover:bg-neutral-800 dark:text-neutral-200"
                        >
                            {copied ? <CheckCircle size={13} className="text-e2o-500" /> : <Copy size={13} />}
                            {copied ? 'Copié !' : 'Copier'}
                        </button>
                        <a
                            href={youtubeConnectUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="shrink-0 flex items-center gap-1 px-3 py-2 text-xs font-medium border border-gray-200 dark:border-neutral-700 rounded-lg hover:bg-gray-50 dark:hover:bg-neutral-800 dark:text-neutral-200"
                        >
                            <ExternalLink size={13} />
                            Voir
                        </a>
                    </div>
                </section>

                <section className="p-fib-5 sm:p-fib-8 bg-white dark:bg-neutral-900 border border-gray-100 dark:border-neutral-800 rounded-2xl shadow-sm">
                    <h3 className="text-lg font-bold mb-fib-2 flex items-center gap-fib-2 text-gray-900 dark:text-white">
                        <Youtube size={20} className="text-red-600" />
                        Chaîne YouTube &amp; playlist
                    </h3>
                    <p className="text-gray-500 dark:text-neutral-400 mb-fib-5">
                        Paramètres YouTube actuellement enregistrés pour cet événement.
                    </p>

                    {youtubeInfoLoading && (
                        <p className="text-sm text-gray-400 dark:text-neutral-500 animate-pulse mb-fib-5">Chargement des infos YouTube…</p>
                    )}

                    {!youtubeInfoLoading && youtubeInfo && !youtubeInfo.access_token_ok && (
                        <p className="text-sm text-amber-600 dark:text-amber-400 mb-fib-5">
                            Aucun compte YouTube connecté pour cette organisation — envoyez le lien de connexion ci-dessus.
                        </p>
                    )}

                    {(youtubeInfo?.channel || youtubeInfo?.playlist) && (
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-fib-3 max-w-2xl mb-fib-5">
                            {youtubeInfo?.channel && (
                                <div className="flex items-center gap-3 border border-gray-200 dark:border-neutral-700 rounded-lg p-3 bg-white dark:bg-neutral-900">
                                    {youtubeInfo.channel.thumbnail
                                        ? <img src={youtubeInfo.channel.thumbnail} alt="" className="w-12 h-12 rounded-full object-cover flex-shrink-0" />
                                        : <div className="w-12 h-12 rounded-full bg-gray-100 dark:bg-neutral-800 flex-shrink-0" />}
                                    <div className="min-w-0">
                                        <div className="text-sm font-semibold text-gray-800 dark:text-white truncate">{youtubeInfo.channel.title || '—'}</div>
                                        <div className="flex items-center gap-3 mt-0.5 text-xs text-gray-500 dark:text-neutral-400">
                                            {!youtubeInfo.channel.hidden_subscriber_count && youtubeInfo.channel.subscriber_count !== null && (
                                                <span className="flex items-center gap-1"><Users size={12} />{formatCount(youtubeInfo.channel.subscriber_count)} abo.</span>
                                            )}
                                            {youtubeInfo.channel.video_count !== null && (
                                                <span className="flex items-center gap-1"><Video size={12} />{formatCount(youtubeInfo.channel.video_count)}</span>
                                            )}
                                            {youtubeInfo.channel.view_count !== null && (
                                                <span className="flex items-center gap-1"><Eye size={12} />{formatCount(youtubeInfo.channel.view_count)}</span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}
                            {youtubeInfo?.playlist && (
                                <div className="flex items-center gap-3 border border-gray-200 dark:border-neutral-700 rounded-lg p-3 bg-white dark:bg-neutral-900">
                                    {youtubeInfo.playlist.thumbnail
                                        ? <img src={youtubeInfo.playlist.thumbnail} alt="" className="w-16 h-9 rounded object-cover flex-shrink-0" />
                                        : <div className="w-16 h-9 rounded bg-gray-100 dark:bg-neutral-800 flex-shrink-0" />}
                                    <div className="min-w-0">
                                        <div className="text-sm font-semibold text-gray-800 dark:text-white truncate">{youtubeInfo.playlist.title || '—'}</div>
                                        <div className="flex items-center gap-1 mt-0.5 text-xs text-gray-500 dark:text-neutral-400">
                                            <ListVideo size={12} />{formatCount(youtubeInfo.playlist.item_count)} vidéos
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-fib-3 max-w-2xl">
                        {[
                            {
                                label: 'Profil YouTube',
                                value: currentEvent?.event_ligne?.youtube_profile,
                                href: currentEvent?.event_ligne?.youtube_profile || null,
                            },
                            {
                                label: 'Channel ID',
                                value: currentEvent?.event_ligne?.youtube_channel_id,
                                href: currentEvent?.event_ligne?.youtube_channel_id ? `https://www.youtube.com/channel/${currentEvent.event_ligne.youtube_channel_id}` : null,
                            },
                            {
                                label: 'Playlist ID',
                                value: currentEvent?.event_ligne?.youtube_playlist_id,
                                href: currentEvent?.event_ligne?.youtube_playlist_id ? `https://www.youtube.com/playlist?list=${currentEvent.event_ligne.youtube_playlist_id}` : null,
                            },
                        ].map(({ label, value, href }) => (
                            <div key={label} className="flex items-center justify-between gap-2 border border-gray-200 dark:border-neutral-700 rounded-lg px-3 py-2 bg-gray-50 dark:bg-neutral-800">
                                <div className="min-w-0">
                                    <div className="text-xs text-gray-500 dark:text-neutral-400">{label}</div>
                                    <div className="text-sm font-mono text-gray-800 dark:text-neutral-200 truncate">{value || '—'}</div>
                                </div>
                                {href && (
                                    <a
                                        href={href}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="shrink-0 text-gray-400 hover:text-e2o-500 transition-colors"
                                        title="Ouvrir"
                                    >
                                        <ExternalLink size={15} />
                                    </a>
                                )}
                            </div>
                        ))}
                    </div>

                    <div className="mt-fib-8 max-w-2xl">
                        <h4 className="text-sm font-bold mb-fib-2 flex items-center gap-1.5 text-gray-900 dark:text-white">
                            <ListVideo size={16} className="text-red-600" />
                            Playlists de destination
                        </h4>
                        <p className="text-xs text-gray-500 dark:text-neutral-400 mb-fib-3">
                            Une vidéo peut être publiée sur l'une de ces playlists, au choix, au moment de l'upload (menu de sélection sur la carte de la vidéo).
                        </p>

                        {playlistsLoading && (
                            <p className="text-sm text-gray-400 dark:text-neutral-500 animate-pulse mb-fib-3">Chargement des playlists…</p>
                        )}

                        {!playlistsLoading && eventPlaylists.length > 0 && (
                            <ul className="space-y-2 mb-fib-3">
                                {eventPlaylists.map(pl => (
                                    <li key={pl.id} className="flex items-center justify-between gap-2 border border-gray-200 dark:border-neutral-700 rounded-lg px-3 py-2 bg-gray-50 dark:bg-neutral-800">
                                        <div className="min-w-0">
                                            <div className="text-sm font-semibold text-gray-800 dark:text-white truncate">
                                                {pl.label || '(sans nom)'}{pl.is_default ? <span className="ml-1.5 text-xs font-normal text-e2o-600">défaut</span> : null}
                                            </div>
                                            <div className="text-xs font-mono text-gray-500 dark:text-neutral-400 truncate">{pl.youtube_playlist_id}</div>
                                        </div>
                                        <div className="flex items-center gap-2 shrink-0">
                                            <a
                                                href={`https://www.youtube.com/playlist?list=${pl.youtube_playlist_id}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-gray-400 hover:text-e2o-500 transition-colors"
                                                title="Ouvrir"
                                            >
                                                <ExternalLink size={15} />
                                            </a>
                                            <button
                                                type="button"
                                                onClick={() => handleDeletePlaylist(pl.id)}
                                                disabled={playlistDeletingId === pl.id}
                                                className="text-gray-400 hover:text-red-500 disabled:opacity-40 transition-colors"
                                                title="Retirer cette playlist"
                                            >
                                                <Trash2 size={15} />
                                            </button>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        )}

                        <div className="flex flex-col sm:flex-row gap-fib-2">
                            <input
                                type="text"
                                value={newPlaylistId}
                                onChange={e => setNewPlaylistId(e.target.value)}
                                placeholder="ID de la playlist YouTube (ex: PLKeGRKOiTBL0…)"
                                className="flex-1 border border-gray-200 dark:border-neutral-700 rounded-lg px-3 py-2 text-sm bg-white dark:bg-neutral-800 text-gray-800 dark:text-white focus:outline-none focus:ring-2 focus:ring-e2o-400"
                            />
                            <input
                                type="text"
                                value={newPlaylistLabel}
                                onChange={e => setNewPlaylistLabel(e.target.value)}
                                placeholder="Nom (optionnel)"
                                className="sm:w-48 border border-gray-200 dark:border-neutral-700 rounded-lg px-3 py-2 text-sm bg-white dark:bg-neutral-800 text-gray-800 dark:text-white focus:outline-none focus:ring-2 focus:ring-e2o-400"
                            />
                            <button
                                type="button"
                                onClick={handleAddPlaylist}
                                disabled={playlistSaving || !newPlaylistId.trim()}
                                className="shrink-0 flex items-center justify-center gap-1 px-3 py-2 text-sm font-medium text-white bg-e2o-500 hover:bg-e2o-600 rounded-lg disabled:opacity-50 transition-colors"
                            >
                                <Plus size={14} />
                                {playlistSaving ? 'Ajout…' : 'Ajouter'}
                            </button>
                        </div>
                    </div>
                </section>

                <div className="flex items-center gap-fib-3 mt-fib-5">
                    <span className="flex items-center justify-center w-6 h-6 rounded-full bg-e2o-500 text-white text-xs font-bold flex-shrink-0">3</span>
                    <h2 className="text-base font-bold text-gray-900 dark:text-white">Relai de la vidéo sur le compte LinkedIn de l'animateur</h2>
                </div>

                <section className="p-fib-5 sm:p-fib-8 bg-white dark:bg-neutral-900 border border-gray-100 dark:border-neutral-800 rounded-2xl shadow-sm">
                    <h3 className="text-lg font-bold mb-fib-2 flex items-center gap-fib-2 text-gray-900 dark:text-white">
                        <Linkedin size={20} className="text-[#0A66C2]" />
                        Animateur(s) de l'événement
                    </h3>
                    <p className="text-gray-500 dark:text-neutral-400 mb-fib-5">
                        Animateur(s) de l'opération à solliciter pour relayer les vidéos sur leur compte LinkedIn.
                    </p>

                    {animateursLoading && (
                        <p className="text-sm text-gray-400 dark:text-neutral-500 animate-pulse">Chargement…</p>
                    )}

                    {!animateursLoading && !animateurs.length && (
                        <p className="text-sm text-gray-400 dark:text-neutral-500">Aucun animateur identifié pour cet événement.</p>
                    )}

                    {!animateursLoading && animateurs.length > 0 && (
                        <div className="flex flex-col gap-fib-3 max-w-2xl">
                            {animateurs.map((item) => {
                                const c = item.contact || {};
                                const hasValorisation = !!c.valorisation_audience;
                                const relaiRaw = item.autorise_relai_linkedin;
                                const relaiValue = relaiRaw === null || relaiRaw === undefined || relaiRaw === ''
                                    ? null
                                    : Number(relaiRaw) === 1;
                                return (
                                    <div key={item.id_conferencier} className="border border-gray-200 dark:border-neutral-700 rounded-lg bg-gray-50 dark:bg-neutral-800 overflow-hidden">
                                        <div className="flex items-center gap-3 px-3 py-2">
                                            {c.photos?.small
                                                ? <img src={c.photos.small} alt="" className="w-9 h-9 rounded-full object-cover flex-shrink-0" />
                                                : <div className="w-9 h-9 rounded-full bg-gray-200 dark:bg-neutral-700 flex-shrink-0" />}
                                            <div className="min-w-0 flex-1">
                                                <div className="text-sm font-semibold text-gray-800 dark:text-white truncate">{c.prenom} {c.nom}</div>
                                                {c.societe && <div className="text-xs text-gray-500 dark:text-neutral-400 truncate">{c.societe}</div>}
                                            </div>
                                            {c.sn_linkedin ? (
                                                <a
                                                    href={c.sn_linkedin}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="shrink-0 text-gray-400 hover:text-e2o-500 transition-colors"
                                                    title="Ouvrir le profil LinkedIn"
                                                >
                                                    <ExternalLink size={15} />
                                                </a>
                                            ) : (
                                                <span className="shrink-0 text-xs text-gray-400 dark:text-neutral-500 italic">Pas de LinkedIn</span>
                                            )}
                                        </div>

                                        {hasValorisation && (
                                            <div className="px-3 py-3 border-t border-gray-200 dark:border-neutral-700 bg-white dark:bg-neutral-900">
                                                <p className="text-sm text-gray-600 dark:text-neutral-300 mb-fib-3">
                                                    Votre animateur <strong>{c.prenom} {c.nom}</strong> {c.valorisation_audience}. Il pourra si vous le souhaitez également diffuser ou reposter les vidéos enregistrées.
                                                </p>
                                                <div className="flex items-center gap-fib-2">
                                                    <button
                                                        onClick={() => handleSetRelaiAutorise(item.id_conferencier, true)}
                                                        disabled={relaiSavingId === item.id_conferencier}
                                                        className={`px-3 py-1.5 text-xs font-medium rounded-lg border disabled:opacity-50 ${relaiValue === true
                                                            ? 'bg-e2o-500 text-white border-e2o-500'
                                                            : 'border-gray-200 dark:border-neutral-700 text-gray-600 dark:text-neutral-300 hover:bg-gray-50 dark:hover:bg-neutral-800'}`}
                                                    >
                                                        Oui
                                                    </button>
                                                    <button
                                                        onClick={() => handleSetRelaiAutorise(item.id_conferencier, false)}
                                                        disabled={relaiSavingId === item.id_conferencier}
                                                        className={`px-3 py-1.5 text-xs font-medium rounded-lg border disabled:opacity-50 ${relaiValue === false
                                                            ? 'bg-gray-700 text-white border-gray-700 dark:bg-neutral-600 dark:border-neutral-600'
                                                            : 'border-gray-200 dark:border-neutral-700 text-gray-600 dark:text-neutral-300 hover:bg-gray-50 dark:hover:bg-neutral-800'}`}
                                                    >
                                                        Non
                                                    </button>
                                                    {relaiValue === null && (
                                                        <span className="text-xs text-gray-400 dark:text-neutral-500 italic">Pas encore répondu</span>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </section>

                <h2 className="text-xs font-semibold uppercase tracking-wide text-gray-400 dark:text-neutral-500 mt-fib-5">Paramètres de votre webcast</h2>

                <section className="p-fib-5 sm:p-fib-8 bg-white dark:bg-neutral-900 border border-gray-100 dark:border-neutral-800 rounded-2xl shadow-sm">
                    <div className="flex items-center justify-between mb-fib-5 max-w-2xl">
                        <h3 className="text-lg font-bold text-gray-900 dark:text-white">Couleurs</h3>
                        {!colorsEditing && (
                            <button
                                onClick={handleColorsEdit}
                                className="shrink-0 flex items-center gap-1 px-3 py-1.5 text-xs font-medium border border-gray-200 dark:border-neutral-700 rounded-lg hover:bg-gray-50 dark:hover:bg-neutral-800 dark:text-neutral-200"
                            >
                                <Pencil size={13} />
                                Éditer
                            </button>
                        )}
                    </div>

                    {colorsEditing ? (
                        <div>
                            <div className="flex gap-fib-8">
                                {COLOR_FIELDS.map(({ label, key }) => {
                                    const value = colorsDraft[key] || '';
                                    const pickerValue = /^#[0-9A-Fa-f]{6}$/.test(value) ? value : '#000000';
                                    return (
                                        <div key={key} className="flex flex-col items-center gap-fib-2">
                                            <div className="text-sm text-gray-600 dark:text-gray-300">{label}</div>
                                            <input
                                                key={`${key}-${colorsEditOpenedAt}`}
                                                type="color"
                                                defaultValue={pickerValue}
                                                onChange={e => setColorsDraft(d => ({ ...d, [key]: e.target.value }))}
                                                className="w-12 h-12 rounded-lg border border-gray-200 dark:border-neutral-700 cursor-pointer bg-transparent p-0.5"
                                            />
                                            <input
                                                type="text"
                                                value={value}
                                                onChange={e => setColorsDraft(d => ({ ...d, [key]: e.target.value }))}
                                                placeholder="#000000"
                                                className="w-24 text-center border border-gray-200 dark:border-neutral-700 rounded-lg px-2 py-1 text-xs font-mono bg-white dark:bg-neutral-900 text-gray-800 dark:text-neutral-200 focus:outline-none focus:ring-2 focus:ring-e2o-500"
                                            />
                                        </div>
                                    );
                                })}
                            </div>
                            <div className="flex items-center gap-fib-2 mt-fib-5">
                                <button
                                    onClick={handleColorsSave}
                                    disabled={colorsSaving}
                                    className="flex items-center gap-1 px-3 py-1.5 text-xs font-medium text-white bg-e2o-500 hover:bg-e2o-600 rounded-lg disabled:opacity-50"
                                >
                                    <CheckCircle size={13} />
                                    {colorsSaving ? 'Enregistrement…' : 'Enregistrer'}
                                </button>
                                <button
                                    onClick={handleColorsCancel}
                                    disabled={colorsSaving}
                                    className="flex items-center gap-1 px-3 py-1.5 text-xs font-medium border border-gray-200 dark:border-neutral-700 rounded-lg hover:bg-gray-50 dark:hover:bg-neutral-800 dark:text-neutral-200 disabled:opacity-50"
                                >
                                    <X size={13} />
                                    Annuler
                                </button>
                            </div>
                        </div>
                    ) : (
                        <div className="flex gap-fib-8">
                            {COLOR_FIELDS.map(({ label, key }) => {
                                const color = colorsValue[key];
                                return (
                                    <div key={key} className="flex flex-col items-center gap-fib-2">
                                        <div className="text-sm text-gray-600 dark:text-gray-300">{label}</div>
                                        <div
                                            className="w-12 h-12 rounded-lg border border-gray-200 dark:border-neutral-700"
                                            style={{ backgroundColor: color || 'transparent' }}
                                        />
                                        <div className="text-xs font-mono text-gray-500 dark:text-neutral-400">{color || '—'}</div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </section>

                {ville && (
                    <section className="p-fib-5 sm:p-fib-8 bg-white dark:bg-neutral-900 border border-gray-100 dark:border-neutral-800 rounded-2xl shadow-sm">
                        <h3 className="text-lg font-bold mb-fib-2 flex items-center gap-fib-2 text-gray-900 dark:text-white">
                            <Film size={20} className="text-e2o-500" />
                            Videos
                        </h3>
                        <h4 className="text-sm font-semibold mb-fib-2 mt-fib-8 text-gray-900 dark:text-white">
                            Footage {ville?.id_cycle_lang?.nom_cycle_lang || '—'}
                        </h4>

                        {villeVideoFootage ? (
                            <div className="max-w-md">
                                <video
                                    controls
                                    className="w-full aspect-video rounded-lg bg-black"
                                    src={villeVideoFootage.file_name_thumbs?.source}
                                />
                                <div className="flex items-center justify-between gap-2 mt-fib-3 border border-gray-200 dark:border-neutral-700 rounded-lg px-3 py-2 bg-gray-50 dark:bg-neutral-800">
                                    <div className="min-w-0">
                                        <div className="text-sm font-mono text-gray-800 dark:text-neutral-200 truncate">{villeVideoFootage.file_name}</div>
                                        <div className="text-xs text-gray-500 dark:text-neutral-400">{villeVideoFootage.date_creation}</div>
                                    </div>
                                    <a
                                        href={villeVideoFootage.file_name_thumbs?.source}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="shrink-0 text-gray-400 hover:text-e2o-500 transition-colors"
                                        title="Ouvrir"
                                    >
                                        <ExternalLink size={15} />
                                    </a>
                                </div>
                            </div>
                        ) : (
                            <p className="text-sm text-gray-400 dark:text-neutral-500">Aucune vidéo de ville rattachée.</p>
                        )}

                        <h4 className="text-sm font-semibold mb-fib-2 mt-fib-8 text-gray-900 dark:text-white">
                            Video footage ligne d'événement
                        </h4>
                        {currentEvent?.event_ligne?.video_footage_event ? (
                            <div className="max-w-md">
                                <video
                                    controls
                                    className="w-full aspect-video rounded-lg bg-black"
                                    src={currentEvent.event_ligne.video_footage_event}
                                />
                                <div className="flex items-center justify-between gap-2 mt-fib-3 border border-gray-200 dark:border-neutral-700 rounded-lg px-3 py-2 bg-gray-50 dark:bg-neutral-800">
                                    <span className="text-sm font-mono text-gray-800 dark:text-neutral-200 truncate">
                                        {currentEvent.event_ligne.video_footage_event.split('/').pop()}
                                    </span>
                                    <a
                                        href={currentEvent.event_ligne.video_footage_event}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="shrink-0 text-gray-400 hover:text-e2o-500 transition-colors"
                                        title="Ouvrir"
                                    >
                                        <ExternalLink size={15} />
                                    </a>
                                </div>
                            </div>
                        ) : (
                            <p className="text-sm text-gray-400 dark:text-neutral-500">Aucune vidéo de ligne d'événement rattachée.</p>
                        )}
                    </section>
                )}

            </div>

        </RegistrationDashboardLayout>
    )
}

export default RegistrationDashbordParams